export { default } from './use-detail-moment'
